import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom' 
import TestingOverview from './FinishedTestingOverview'
import TestingDescription from './FinishedTestingDescription'

class ReportFinished extends Component {
  state = {
    isLoading: false,
  }

  static defaultProps = {
    collection: []
  }

  componentDidMount () {
    this.loadStats()
  }
  spinOnLoading = () => { this.setState({ isLoading: true }) }
  spinOffLoading = () => { this.setState({ isLoading: false }) }
  loadStats = async() => {
    const { year } = this.props
    this.spinOnLoading()
    await this.props.loadStats('finished', year)
    this.spinOffLoading()
  }

  loadDetail = async(year, month, type) => {
    this.spinOnLoading() 
    let monthString = month < 10 ? `0${month}` : month
    const res = await this.props.loadStatsDetail('finished', year, monthString, type )
    this.spinOffLoading()
    return res
  }

  loadType = async(year, month) => {
    this.spinOnLoading()
    let monthString = month < 10 ? `0${month}` : month
    await this.props.loadStatsType('finished', year, monthString)
    this.spinOffLoading()
  }

  getStatFinishedTestingTransaction = async(year, month) => {
    this.spinOnLoading()
    let monthString = month < 10 ? `0${month}` : month
    const res = await this.props.getStatFinishedTestingTransaction(year, monthString )
    this.spinOffLoading()
    return res
  }
  render () { 
    return (
      <div>
        <Switch>
          <Route exact
            path='/reportfinished'
            render={() => <TestingOverview
              spinOnLoading={this.spinOnLoading}
              spinOffLoading={this.spinOffLoading}
              loadDetail={this.loadDetail}
              loadType={this.loadType}
              {...this.props} />
            }
          />

          <Route exact
            path='/reportfinished/description'
            render={() => <TestingDescription
              spinOnLoading={this.spinOnLoading}
              spinOffLoading={this.spinOffLoading}
              loadDetail={this.loadDetail}
              loadType={this.loadType}
              getTransaction={this.getStatFinishedTestingTransaction}
              {...this.props} />
            }
          />
        </Switch>
      </div>
    )
  }
}

export default ReportFinished
